module.exports = __webpack_public_path__ + "static/media/a1.50a1635.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/penny/a1.mp3
// module id = 7FEk
// module chunks = 0